<script setup>
import { computed } from 'vue';

defineProps({
  target: {
    type: String,
    default: '',
  },
  ariaLabelTitle: {
    type: String,
    default: '',
  },
});

// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;
const imageBind = computed(() => `url(  ${baseUrl}/svg/info_circle.svg)`);
</script>

<template>
  <button
    type="button"
    data-bs-toggle="offcanvas"
    :data-bs-target="`#${target}`"
    :aria-controls="target"
    :aira-label="ariaLabelTitle"
  />
</template>

<style lang="scss" scoped>
button {
  background-image: v-bind(imageBind);
  background-repeat: no-repeat;
  width: 2.2rem;
  height: 2.3rem;
  border: none;
  display: flex;
  background-color: transparent;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 0;
  margin-top: -0.4rem;
}
</style>
